import axios from 'axios';
import { PencilLine } from '@phosphor-icons/react';
import React, { useState, useMemo } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import { Label } from 'reactstrap'
import { environment } from '../../env';
import { successModalToggle, loaderAction, getSendFromAction } from '../../redux/actions/Index';
import ErrorComponents from '../errorComponents/ErrorComponents';
import { isValidPhoneNumber, isPossiblePhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import PhoneInput, { formatPhoneNumberIntl, formatPhoneNumber, } from "react-phone-number-input";
import 'react-phone-number-input/style.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function AddFloorType({ button, title, data }, ...props) {
    const [modal, setModal] = useState(false);
    const [editt, setEdit] = useState(false);
    const [ID, setID] = useState(0);
    const [btndis, setBtndis] = useState(false)
    const [buildingTypeError, setBuildingTypeError] = useState()
    const preventNegativeValuesspi = (e) => ["+", "-", "!", "@", "#", "$", "%", "^", "&", "*", "=", "/", "_"].includes(e.key) && e.preventDefault()
    const [panerror, setPanError] = useState('');
    const [contactError, setContactError] = useState(false);

    const toggle = () => { setModal(!modal); setEdit(!editt) }
    const dispatch = useDispatch()
    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        control,
        formState: { errors },
    } = useForm();
    const name = watch("name");
    const pann = watch('pan');

    const handelTest = (value) => {
        if(value != undefined){
            if(!isValidPhoneNumber(value)){
                setContactError(true);
            }else{
                let parsedNumber = parsePhoneNumber(value);
                if(parsedNumber?.country == "IN"){
                    if(parsedNumber?.nationalNumber.length == 10){
                        setContactError(false);    
                    }else{
                        setContactError(true);
                    }
                }else{
                    setContactError(false);
                }
            }
        }
    }

    const checkGst = (data) => {
        let flag = false
        if (data.length > 0) {
          if (pann != undefined && data.length == 15) {
            for (let i = 2; i < 12; i++) {
              if (data[i].toUpperCase() != pann[i - 2].toUpperCase()) {
                flag = true
              }
            }
          } else {
            flag = true
          }
        } else if (data.length == 0) {
          flag = false
        }
        if (flag == true) {
            setPanError('Please Enter Correct GST Number')
            setBtndis(false)
        } else {
            setPanError('')
            setBtndis(true)
        }
    }
    const onSubmit = async (data) => {
        setBtndis(true);
        dispatch(loaderAction(true))
        if(data.contact != undefined && !isValidPhoneNumber(data.contact)){
            setBtndis(false)
            return
        }
        try {
            if (button != 'edit') {
                await axios.post(`${environment.baseUrl}bill-send-from/`, data).then((form) => {
                    if (form.data.code === 200) {
                        dispatch(successModalToggle());
                        dispatch(loaderAction(false));
                        getSendFrom();
                        toggle();
                        reset();
                        setBtndis(false)
                        toast.success('Bill Send From Added Successfully', {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: false,
                        });
                    }else if(form.data.code === 5005){
                        dispatch(loaderAction(false))
                        setBtndis(false)
                        console.log(err);
                        toast.error(form.data?.message, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: false,
                        });
                    }
                    else {
                        dispatch(loaderAction(false))
                        setBtndis(false)
                        console.log(err);
                        toast.error('Internal Server Error', {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: false,
                        });
                    }
                })
            } else {
                await axios.put(`${environment.baseUrl}bill-send-from/${ID}`, data).then((form) => {
                    if (form.data.code === 200) {
                        dispatch(successModalToggle());
                        dispatch(loaderAction(false));
                        getSendFrom();
                        toggle();
                        reset();
                        setBtndis(false)
                        toast.success('Bill Send From Edited Successfully', {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: false,
                        });
                    }else if(form.data.code === 5005){
                        dispatch(loaderAction(false))
                        setBtndis(false)
                        console.log(err);
                        toast.error(form.data?.message, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: false,
                        });
                    } else {
                        dispatch(loaderAction(false))
                        setBtndis(false)
                        console.log(err);
                        toast.error('Internal Server Error', {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: false,
                        });
                    }
                })
            }
        }
        catch (err) {
            dispatch(loaderAction(false));
            setBtndis(false);
            console.log(err);
        }
    };

    const CancelButton = () => {
        toggle();
        reset();
        setBtndis(false);
        setBuildingTypeError("")        
    }

    const getSendFrom = () => {
        try {
            axios.get(`${environment.baseUrl}bill-send-from/`).then(res => {
                dispatch(getSendFromAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    useMemo(() => {
        if (!name) {
            setBuildingTypeError("")
        }
    }, [name])
    useMemo(() => {
        if (button == 'edit') {
            reset({ 
                'name': data.name,
                'address' : data.address,
                'email': data.email,
                'contact': data.contact,
                'pan' : data.pan,
                'gst' : data.gst,
                'cin' : data.cin
             })
            setID(data.id)
        }
    }, [editt])

    const numaricAndSymbol = (inputString) => {
        const match = inputString.match(/[!@#$%^&*`~+=;?":/\\[\]{}|<>]/);
        return match ? true: false;
      }
    
    const isAlphaHandeler = (event,filedName) => {
        event.preventDefault();
        let tempString = event.target.value;
        let numberOccurance = tempString.length;
        for(let i=0;i< tempString.length;i++){
            if(numaricAndSymbol(tempString[i])){
            numberOccurance = i;
            break;
            }
        }

        tempString = tempString.substring(0,numberOccurance);

        tempString = tempString.toLowerCase().split(' ').map(function (word) {
            return (word.charAt(0).toUpperCase() + word.slice(1));
        }).join(' ');
        setValue(filedName, tempString)
    }

    return (
        <>
            {button != "edit" ? (
                <Button
                    onClick={toggle}
                    className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5 mb-5"
                >
                    <span className="fs-3 d-flex gap-3 title-font-600 px-3">
                        Add Bill Send From
                    </span>
                </Button>
            ) : (
                <button
                    onClick={toggle}
                    className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' /></button>
            )} <Modal className='border-0' isOpen={modal} toggle={props.toggle} size="lg" centered>
                <ModalHeader className='bg-base-color ' ><span className='title-font-700 fs-36 text-base-white'>{title}</span></ModalHeader>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <ModalBody className='bg-background-color px-5'>
                        <div className="row">
                            <div className='col-12  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    Name*
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <input
                                        className='p-3  border-radius-10 shadow-none w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='text'
                                        placeholder='Enter Bill Send From...'
                                        {...register("name", { required: true, onChange: (e) => { isAlphaHandeler(e,"name") } })}
                                    />
                                </div>
                                {errors.name && <ErrorComponents error={'Bill Send From is required *'} />}
                                {buildingTypeError && <ErrorComponents error={buildingTypeError} />}
                                <br />
                            </div>
                            <div className='col-12  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    Address*
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <input
                                        className='p-3  border-radius-10 shadow-none w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='text'
                                        placeholder='Address'
                                        {...register("address", { required: true, onChange: (e) => { isAlphaHandeler(e,'address') } })}
                                    />
                                </div>
                                {errors.address && <ErrorComponents error={'Address is required *'} />}
                                {buildingTypeError && <ErrorComponents error={buildingTypeError} />}
                                <br />
                            </div>
                            <div className='col-12  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    Email*
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <input
                                        className='p-3  border-radius-10 shadow-none w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='email'
                                        placeholder='Email'
                                        {...register("email", { required: true,})}
                                    />
                                </div>
                                {errors.email && <ErrorComponents error={'Email is required *'} />}
                                <br />
                            </div>
                            <div className='col-12  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    Contact*
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <Controller
                                        name="contact"
                                        control={control}
                                        rules={{required: "Contact Number is Required*",}}
                                        render={({field})=> (
                                            <PhoneInput
                                                id="contact_number"
                                                {...field} 
                                                className='d-flex border-radius-10 shadow-none px-4  w-100 fs-4 title-font-500 fs-2 modal-input bg-white py-1'
                                                onChange={(e)=>{handelTest(e);field.onChange(e)}}
                                                defaultCountry='IN'
                                                placeholder={"1234567890"}
                                            />
                                        )}
                                    />
                                </div>
                                {(!contactError && errors.contact) && <ErrorComponents error={'Contact is required *'} />}
                                {contactError && <ErrorComponents error={'Enter a valid number*'} />}
                                <br />
                            </div>
                            <div className='col-12  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    PAN*
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <input
                                        className='p-3  border-radius-10 text-uppercase shadow-none w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='text'
                                        placeholder='PAN No.'
                                        onKeyDown={preventNegativeValuesspi}
                                        {...register("pan", { required: true, pattern: {
                                            value: /^([A-Z]{5})(\d{4})([A-Z])$/,
                                            message: "Enter valid Pan No"
                                          }, onChange: (e) => { e.target.value = e.target.value.toUpperCase() }})}
                                    />
                                </div>
                                {errors.pan && <ErrorComponents error={"Enter valid Pan No"} />}
                                <br />
                            </div>
                            <div className='col-12  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    GST*
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <input
                                        className='p-3  border-radius-10 text-uppercase shadow-none w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='text'
                                        onKeyDown={preventNegativeValuesspi}
                                        placeholder='GST No.'
                                        {...register("gst", { required: true, onChange: (e) => { e.target.value = e.target.value.toUpperCase() }, onBlur: (e) => { checkGst(e.target.value) } })}
                                    />
                                </div>
                                {errors.gst && <ErrorComponents error={'GST is required *'} />}
                                {panerror && (<ErrorComponents error={panerror} />)}
                                <br />
                            </div>
                            <div className='col-12  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    CIN *
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <input
                                        className='p-3  border-radius-10 text-uppercase shadow-none w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='text'
                                        onKeyDown={preventNegativeValuesspi}
                                        placeholder='CIN'
                                        {...register("cin", { required: true, onChange: (e) => { e.target.value = e.target.value.toUpperCase() }, })}
                                    />
                                </div>
                                    {errors.cin && <ErrorComponents error={'CIN is required *'} />}
                                <br />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={CancelButton}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Cancel</span></Button>{' '}
                        <Button className='border-radius-7 p-3 d-flex align-items-center buttons'><span className='fs-4 d-flex gap-3 title-font-600 px-3'>{button != "edit" ? "Add" : "Save"}</span></Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </>
    )
};


export default AddFloorType